// extracted by mini-css-extract-plugin
export default {"imageSkeleton":"Skeletons_imageSkeleton__u5gW-"};